import { useQueryClient } from "@tanstack/react-query";

import type { IRowsDtoWrapper } from "app/pages/sales-intelligence/modules/top-companies/types/rowsDtoWrapper";
import type { ITopCompanyItem } from "app/pages/sales-intelligence/modules/top-companies/types/TopCompany";
import type { IRevealedContactResponse } from "app/pages/sales-intelligence/sub-modules/contacts-search/query/queries/useSingleRevealContactInfoQuery";
import useSingleRevealContactInfoQuery from "app/pages/sales-intelligence/sub-modules/contacts-search/query/queries/useSingleRevealContactInfoQuery";
import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

import { topCompaniesQueryKeys } from "../query/queryKeys/queryKeyFactory";

interface IResult {
    isLoading: boolean;
    reveal: () => void;
}

function useTopCompanyContactReveal(contact: ContactSearchEntry): IResult {
    const queryClient = useQueryClient();

    const mutation = useSingleRevealContactInfoQuery(({ revealedInfo }: IRevealedContactResponse) => {
        queryClient.setQueryData(
            topCompaniesQueryKeys.companiesList(),
            (oldData: IRowsDtoWrapper<readonly ITopCompanyItem[]>) => ({
                rows: oldData?.rows?.map((item: ITopCompanyItem) =>
                    item?.selectedContact?.id === contact.id
                        ? {
                              ...item,
                              selectedContact: {
                                  ...item.selectedContact,
                                  isRevealed: true,
                                  privateData: revealedInfo,
                              },
                          }
                        : item,
                ),
            }),
        );
    });

    return {
        isLoading: mutation.isPending,
        reveal: () => mutation.mutate(contact),
    };
}

export default useTopCompanyContactReveal;
